import { PureComponent } from 'react';
import { Button } from 'foundations-components/transitional/components/Button';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import I18n from 'I18n';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { CRM_FULL_WIDTH } from '../../crm-sidebar/constants';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class ContactSidebarAsyncError extends PureComponent {
  render() {
    const {
      retry
    } = this.props;
    return /*#__PURE__*/_jsx(View, {
      backgroundColor: "fill-surface-default",
      blockSize: "100%",
      inlineSize: `${CRM_FULL_WIDTH}px`,
      insetInlineEnd: "0",
      overflowY: "auto",
      position: "absolute",
      children: /*#__PURE__*/_jsx(Flex, {
        alignItems: "center",
        flexDirection: "column",
        flex: "1 0 100%",
        paddingInline: "200",
        children: /*#__PURE__*/_jsxs(ErrorMessage, {
          title: I18n.text('conversations-inbox-ui.contactLoadingError.title'),
          illustrationProps: {
            width: '100'
          },
          children: [/*#__PURE__*/_jsx("p", {
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "conversations-inbox-ui.contactLoadingError.message"
            })
          }), /*#__PURE__*/_jsx(Button, {
            use: "tertiary",
            size: "xs",
            onClick: retry,
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "conversations-inbox-ui.contactLoadingError.retryButtonLabel"
            })
          })]
        })
      })
    });
  }
}
ContactSidebarAsyncError.displayName = 'ContactSidebarAsyncError';